export default {
    BASE_URL: '/pms/attence/audit',
    api: [
        {
            name: 'list',
            desc: '考勤列表信息',
            method: 'POST',
            path: '/list'
        },
        {
            name: 'detailList',
            desc: '考勤详情列表信息',
            method: 'POST',
            path: '/detail'
        },
        {
            name: 'audit',
            desc: '审核通过不通过',
            method: 'PUT',
            path: ''
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/project/clocking.js